<template>
  <div class="SupportPartners">
    <!-- 首頁圖 -->
    <div class="banner">
      <h1>{{ $t("supportpartners.banner_title") }}</h1>
    </div>
    <!-- 內容欄 -->
    <div class="content-container">
      <!-- 捐款者芳名錄 -->
      <div class="title">
        <span v-html="supportData.tit1"></span>
      </div>
      <p class="tips" v-html="supportData.con1"></p>
      <!-- 创始赞助 -->
      <div class="title">
        <span>{{ $t("supportpartners.donors_tit") }}</span>
      </div>
      <ul class="partner-list">
        <div class="img-box">
          <img src="../assets/img/support/SC Logo_CMYK.jpg" alt="" />
        </div>
        <li v-for="item in supportData.donors_data" :key="item">
          <i class="list-mark"></i>
          {{ item }}
        </li>
      </ul>
      <div v-for="(item, index) in supportData.support_order" :key="index">
        <div class="title">
          <span v-html="item.tit"></span>
        </div>
        <p class="tips" v-html="item.con"></p>
      </div>
      <!-- <div>
        <div class="title">
          <span>如何捐款？</span>
        </div>
        <p class="tips">
          為了推展本獎學金計劃，您的贊助對本會的受惠舊生意義重大。我們希望社會各界繼續支持本獎學金，讓有需要的舊生可以持續投入體育培訓，發展所長，實現理想。有意贊助獎學金者可透過銀行入賬、劃線支票、PayMe或PayPal的方式捐款。
        </p>
      </div>
      <div>
        <div class="title">
          <span>贊助凝動持續運動訓練獎學金</span>
        </div>
        <p class="tips">
          有意贊助獎學金者可透過銀行入賬、劃線支票、PayMe或PayPal的方式捐款，並填妥捐款表格［link］。本會職員稍後會儘快聯絡捐款人或機構再作跟進。
        </p>
      </div> -->
      <!-- 捐款方式 -->
      <div class="dona-method-container">
        <div
          class="dona-method-item"
          v-for="(item, index) in supportData.dona_methods"
          :key="index"
        >
          <p class="tit" v-html="item.tit"></p>
          <p class="con" v-html="item.con"></p>
        </div>
      </div>
      <!-- 赞助奖学金按钮 -->
      <div @click="openWindow()" class="sponsor-btn apply-btn">
        {{ supportData.btn_content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupportPartners",
  data() {
    return {
      currentItem: 0,
    };
  },
  components: {},
  methods: {
    openWindow() {
      if (this.$t("msg.hello") !== "hello") {
        window.open(
          "https://donation.inspiringhk.org/zh/campaigns/view/3",
          "_blank"
        );
      } else {
        window.open(
          "https://donation.inspiringhk.org/eng/campaigns/view/2",
          "_blank"
        );
      }
    },
  },
  computed: {
    supportData: function() {
      return this.$t("supportpartners");
    },
  },
};
</script>

<style scoped lang="scss">
.SupportPartners {
  .banner {
    background-image: url("../assets/img/support/donate partner.jpg");
  }
  .content-container {
    .sponsor-btn {
      border: solid 1px;
      text-align: center;
      color: #229fd8;
      margin-top: 45px;
      font-weight: 500;
      cursor: pointer;
      padding: 0 3%;
      font-size: 18px;
      display: inline-block;
      line-height: 38px;
    }
    .active {
      color: white !important;
      background: #229fd8;
    }
    .tips {
      margin: 3.1vw 0;
    }
    .partner-list {
      margin-top: 4.2vw;
      & > li {
        position: relative;
        text-indent: 20px;
        color: #444;
        .list-mark {
          top: 0;
          background: #444;
        }
      }
    }
    .dona-method-container {
      line-height: 24px;
      .dona-method-item {
        margin-top: 20px;
      }
      .tit {
        font-weight: 600;
      }
    }
    .apply-btn {
      display: block;
      background: #85c357;
      color: white;
      margin: 3.1vw auto;
      width: 20%;
    }
    .img-box {
      margin-bottom: 10px;
      & > img {
        width: 20%;
      }
    }
  }
}
@media (max-width: 768px) {
  .SupportPartners {
    .content-container {
      .sponsor-btn {
        line-height: 30px;
        font-size: 12px;
      }
      .title {
        font-size: 18px;
      }
      .partner-list {
        margin-top: 4.2vw;
        & > li {
          .list-mark {
            height: 16px;
          }
        }
      }
      .apply-btn {
        width: 38vw;
      }
      .img-box {
        & > img {
          width: 50%;
        }
      }
    }
  }
}
</style>
